var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-8 col-xl-9" },
                    [
                      _c("h2", [_vm._v("Moje údaje")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form", { on: { submit: _vm.formSubmit } }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c("label", { attrs: { for: "meno" } }, [
                              _vm._v("Meno")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.meno,
                                  expression: "meno"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.meno },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.meno = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v("E-mail")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "email", readonly: "" },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c("label", [_vm._v("Okres")]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                staticClass: "custom-select",
                                attrs: { type: "text" },
                                on: {
                                  change: function($event) {
                                    return _vm.onChange($event.target.value)
                                  }
                                }
                              },
                              _vm._l(_vm.okresy, function(item) {
                                return _c(
                                  "option",
                                  {
                                    domProps: {
                                      value: item.name,
                                      selected:
                                        _vm.profil.pouzivatel_id
                                          .pouzivatel_okres == item.name
                                          ? "selected"
                                          : ""
                                    }
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-checkbox mb-2"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.suhlas1,
                                      expression: "suhlas1"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "customCheck1"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.suhlas1)
                                      ? _vm._i(_vm.suhlas1, null) > -1
                                      : _vm.suhlas1
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.suhlas1,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.suhlas1 = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.suhlas1 = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.suhlas1 = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(0)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-checkbox mb-2"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.suhlas2,
                                      expression: "suhlas2"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "customCheck2"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.suhlas2)
                                      ? _vm._i(_vm.suhlas2, null) > -1
                                      : _vm.suhlas2
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.suhlas2,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.suhlas2 = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.suhlas2 = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.suhlas2 = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(1)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-checkbox mb-2"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.suhlas3,
                                      expression: "suhlas3"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "customCheck3"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.suhlas3)
                                      ? _vm._i(_vm.suhlas3, null) > -1
                                      : _vm.suhlas3
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.suhlas3,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.suhlas3 = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.suhlas3 = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.suhlas3 = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(2)
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-checkbox mb-2"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.suhlas4,
                                      expression: "suhlas4"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "customCheck4"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.suhlas4)
                                      ? _vm._i(_vm.suhlas4, null) > -1
                                      : _vm.suhlas4
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.suhlas4,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.suhlas4 = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.suhlas4 = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.suhlas4 = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(3)
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(4)
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck1" } },
      [
        _vm._v(
          "\n                                        Súhlasím so zasielaním "
        ),
        _c("strong", [_vm._v("reklamných emailov")]),
        _vm._v(".\n                                    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck2" } },
      [
        _vm._v(
          "\n                                        Súhlasím so zasielaním "
        ),
        _c("strong", [_vm._v("informačných emailov")]),
        _vm._v(" z hry Adoptuj kravičku.\n                                    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck3" } },
      [
        _vm._v(
          "\n                                        Súhlasím so zasielaním "
        ),
        _c("strong", [
          _vm._v("informačných emailov ohľadom stavu mojich kravičiek")
        ]),
        _vm._v(" v hre Adoptuj kravičku.\n                                    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "custom-control-label", attrs: { for: "customCheck4" } },
      [
        _vm._v(
          "\n                                        Súhlasím so zaradením do "
        ),
        _c("strong", [_vm._v("verejných štatistík")]),
        _vm._v(" v hre (leader boardov).\n                                    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c(
        "button",
        { staticClass: "btn --primary", attrs: { type: "submit" } },
        [
          _vm._v("\n                                        Uložiť "),
          _c("span", { staticClass: "icon" })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }